export const isParagraphBlock = (value: string): boolean => value === "p";
